import { FC, useRef } from 'react';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { ReactionsRow } from '../reactions/ReactionsRow';
import { CommentList } from '../../comments/CommentList';
import { ViewNoteSection } from './ViewNoteSection';
import { CommentIcon } from '../../theme/Icons';

// The reactions, counts and comments under a note, for every reader who can see it.
export const NoteInteractions: FC<{
    note: ICaremapNoteResponse;
    authenticatedRedirect: string;
}> = ({ note, authenticatedRedirect }) => {
    const commentsRef = useRef<HTMLDivElement>(null);

    const scrollToComments = () => {
        commentsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <div data-type="note-interactions" style={{ marginTop: 24 }}>
            <ReactionsRow
                note={note}
                surface="note_detail"
                authenticatedRedirect={authenticatedRedirect}
                commentCntClickHandler={scrollToComments}
            />
            <div ref={commentsRef} data-type="note-comments">
                <ViewNoteSection title="Comments" Icon={CommentIcon}>
                    <CommentList note={note} surface="note_detail" />
                </ViewNoteSection>
            </div>
        </div>
    );
};
